import React, { useRef, useState, useMemo, useEffect } from "react";
import { useGLTF, Float, ContactShadows, useAnimations } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import staticVertex from '../staticVertex.glsl';
import fragment from './fragment.glsl';

// const ANIMATION_CONFIG = {
//   speed: 0.7,
//   secondarySpeed: 0.4,
//   endRotationY: Math.PI / 2,
//   rotationSpeed: 0.65,
//   startPosition: { x: 10, y: 10, z: 6 },
//   endPosition: { x: 0, y: 0, z: 0 }
// };

export default function Heliport(props) {

  // const { size = [8, 8], shadowOpacity = 0.35, position = [0, 0, 0], rotation = [-Math.PI / 2, 0, 0], lightPosition: lightPos, receiveShadow, playing = true,  ...primitiveProps } = props;
  const { size = [8, 8], shadowOpacity = 0.35, position = [0, 0, 0], rotation = [-Math.PI / 2, 0, 0], ...primitiveProps } = props;

  // const heliportRef = useRef();
  // const targetShadowOpacityRef = useRef(0);

  // const [shadowOpacity, setShadowOpacity] = useState(0);

  // CARGAR MODELO Y APLICAR SHADER
    // const heliport = useGLTF('./models/ext/Heliport_basev2.glb')

  // const { scene: originalScene, animations } = useGLTF('./models/ext/Heliport_base.glb')
// const { actions } = useAnimations(animations, helicopterRef);

const material = useMemo(() => new THREE.ShadowMaterial({ opacity: shadowOpacity }), [shadowOpacity]);
  

// const scene = useMemo(() => {
//     const clonedScene = heliport.scene.clone();
//     const lightPosition = new THREE.Vector3(...lightPos);
    
//     clonedScene.traverse((child) => {
//       if (child.isMesh) {
        
//         if (receiveShadow) {
//           child.receiveShadow = true;
//         }
//       }
//     });
    
//     return clonedScene;
//   }, []);




  

  return (
    <>
      <mesh
        position={position}
        rotation={rotation}
        receiveShadow
        {...props}
      >
        <planeGeometry args={size} />
        <primitive object={material} attach="material" />
      </mesh>
      {/* <primitive 
        ref={heliportRef}
        object={scene}
        scale={10}
        position={[0, 0, 0]}
        // rotation-y={-Math.PI/2}
        {...primitiveProps}
        receiveShadow
      /> */}
        </>

  );
}

// useGLTF.preload('./models/ext/Heliport_base.glb');
